import { Component, computed, inject } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { COMPLIANCE_URL } from '../core/compliance-link';
import { GmrDataService } from '../core/gmr-data.service';
import { getUnavailableAlert } from '../core/unavailable-alert';
import { UiStateService } from '../core/ui-state.service';

//
// 1:1 port of the .mySettings / .settingsOverlay block in menu.html.
//
@Component({
  selector: 'app-user-settings-modal',
  standalone: true,
  imports: [TranslateDirective, TranslatePipe],
  //
  // .mySettings and .settingsOverlay are independently position:absolute - the host just needs
  // to not collapse to display:inline's default box behavior around them.
  //
  styles: [':host { display: block; }'],
  templateUrl: './user-settings-modal.component.html',
})
export class UserSettingsModalComponent
{
  protected readonly data = inject(GmrDataService);
  protected readonly ui = inject(UiStateService);

  protected readonly myInfo = computed(() => this.data.myInfo());
  protected readonly unavailableStats = computed(() => this.data.unavailableStats());
  protected readonly unavailableAlert = computed(() => getUnavailableAlert(this.unavailableStats()));
  protected readonly complianceUrl = COMPLIANCE_URL;

  //
  // 1:1 port of "Don't show MAX API calls when it's the same value as MIN."
  //
  protected readonly showApiCallLimits = computed(() =>
  {
    const info = this.myInfo();
    return !info || info.daily_limit_max !== info.daily_limit_min;
  });

  protected readonly showApiRemainingCalls = computed(() =>
  {
    const info = this.myInfo();
    return !info || info.daily_remaining_max !== info.daily_remaining_min;
  });
}
